import { createContext, useContext, useMemo, useState } from 'react';

type PageHeaderContextType = {
  height?: number;
  setHeight?: (height: number) => void;
};

export const PageHeaderContext = createContext<PageHeaderContextType>({});

/**
 * An optional provider to track the context (e.g. height) of the PageHeader component.
 */
export const PageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [height, setHeight] = useState<number>();

  const value = useMemo(() => ({ height, setHeight }), [height]);

  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>;
};

/**
 * Get the context (e.g. height) of the closest PageHeader if is wrapped inside PageHeaderProvider.
 */
export const usePageHeaderContext = () => {
  return useContext(PageHeaderContext);
};
